export const SET_EXPERIMENT = 'SET_EXPERIMENT';
export const OPTIMIZE_READY = 'OPTIMIZE_READY';

export const GROWTHBOOK_LOADED = 'GROWTHBOOK_LOADED';
